import { useState } from "react";
import { sls, SIGTE_SESSION_KEY, sigteApiFetch } from "./sigteUtils";
import { SigteLogin } from "./SigteLogin";
import { SigteClientes } from "./SigteClientes";
import { SigteEdificios } from "./SigteEdificios";
import { SigteEquipos } from "./SigteEquipos";
import { SigteCatalogos } from "./SigteCatalogos";
import { SigteInspeccion } from "./SigteInspeccion";

var SIGTE_BRAND = "#0F2C70";

export default function SigteApp() {
  var [session,setSession]=useState(function(){return sls.get(SIGTE_SESSION_KEY,null);});
  var [tab,setTab]=useState("clientes");
  var [selectedCliente,setSelectedCliente]=useState(null);
  var [selectedEdificio,setSelectedEdificio]=useState(null);

  function login(u){ sls.set(SIGTE_SESSION_KEY,u); setSession(u); }
  function logout(){
    sigteApiFetch("/logout",{method:"POST"}).catch(function(){});
    sls.set(SIGTE_SESSION_KEY,null);
    setSession(null); setSelectedCliente(null); setSelectedEdificio(null);
  }
  function goClientes(){ setTab("clientes"); setSelectedCliente(null); setSelectedEdificio(null); }
  function goCatalogos(){ setTab("catalogos"); }
  function goInspeccion(){ setTab("inspeccion"); }

  if(!session) return <SigteLogin onLogin={login}/>;

  var body;
  if(tab==="inspeccion"){
    body = <SigteInspeccion/>;
  } else if(tab==="catalogos"){
    body = <SigteCatalogos/>;
  } else if(selectedEdificio){
    body = <SigteEquipos edificio={selectedEdificio} onBack={function(){setSelectedEdificio(null);}}/>;
  } else if(selectedCliente){
    body = <SigteEdificios cliente={selectedCliente} onBack={function(){setSelectedCliente(null);}} onOpenEdificio={setSelectedEdificio}/>;
  } else {
    body = <SigteClientes onOpenCliente={setSelectedCliente}/>;
  }

  return (
    <div style={{minHeight:"100vh",background:"#f1f5f9",fontFamily:"'Inter','Segoe UI',sans-serif"}}>
      <div style={{background:SIGTE_BRAND,padding:"14px 28px",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10}}>
        <div style={{display:"flex",alignItems:"center",gap:18}}>
          <p style={{color:"#fff",fontWeight:800,fontSize:16,margin:0,fontFamily:"Georgia,serif",letterSpacing:2}}>SIGTE</p>
          <div style={{display:"flex",gap:4,background:"rgba(255,255,255,0.12)",borderRadius:9,padding:3}}>
            <button onClick={goClientes} style={{padding:"7px 14px",borderRadius:7,border:"none",cursor:"pointer",fontSize:12,fontWeight:600,background:tab==="clientes"?"#fff":"transparent",color:tab==="clientes"?SIGTE_BRAND:"rgba(255,255,255,0.8)"}}>Clientes</button>
            <button onClick={goInspeccion} style={{padding:"7px 14px",borderRadius:7,border:"none",cursor:"pointer",fontSize:12,fontWeight:600,background:tab==="inspeccion"?"#fff":"transparent",color:tab==="inspeccion"?SIGTE_BRAND:"rgba(255,255,255,0.8)"}}>Inspección</button>
            <button onClick={goCatalogos} style={{padding:"7px 14px",borderRadius:7,border:"none",cursor:"pointer",fontSize:12,fontWeight:600,background:tab==="catalogos"?"#fff":"transparent",color:tab==="catalogos"?SIGTE_BRAND:"rgba(255,255,255,0.8)"}}>Catalogos</button>
          </div>
        </div>
        <div style={{display:"flex",alignItems:"center",gap:14}}>
          <span style={{color:"rgba(255,255,255,0.7)",fontSize:12}}>{session.nombre+" · "+(session.rol||"")}</span>
          <button onClick={logout} style={{background:"rgba(255,255,255,0.15)",border:"none",borderRadius:8,padding:"8px 14px",color:"#fff",fontSize:12,cursor:"pointer",fontWeight:600}}>Cerrar sesion</button>
        </div>
      </div>
      <div style={{maxWidth:1000,margin:"0 auto",padding:"32px 20px"}}>
        {body}
      </div>
    </div>
  );
}
